var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"deal-types__tab",class:{'deal-types__tab--active' : _vm.state}},[_c('input',{attrs:{"type":"radio"},domProps:{"value":_vm.value,"checked":_vm.state},on:{"change":_vm.onChange}}),_vm._v("\n"+_vm._s(_vm.label)+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-16b45e39","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/radio.vue
// module id = 263
// module chunks = 0